import React, {Fragment} from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {flexAlignCenter, mb, p, pv, w100} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {ContractorDescriptionPopup} from "./ContractorDescriptionPopup";
import {RegisterCompanyButton} from "./RegisterCompanyButton";

const chartImage = require("../images/chart.png");

export const ContractorDescription = () => {
    const theme = useTheme();

    return (
        <section css={contractorDescription}>
            <Text align="center" css={mb(3)} variant="headline_2">
                Ty projektujesz, my pomagamy Ci zyskać nowych klientów!
            </Text>
            <Text align="center">
                Zaufało nam ponad 1 000 renomowanych deweloperów, dzięki którym udostępniamy blisko 70 000 ofert. Satysfakcję naszych użytkowników podkreślają
                dane PBS. Ponad 80% z nich uznało, że Rynek Pierwotny jest dobrym miejscem na wyszukiwanie nowych ofert nieruchomości. Przekonaj się i Ty, załóż
                bezpłatny profil specjalisty i zyskaj nowych klientów.
            </Text>

            <div css={content}>
                <div css={chartWrapper}>
                    <img alt="chart" css={chart} src={chartImage} />

                    <ContractorDescriptionPopup
                        css={clients}
                        text={
                            <Fragment>
                                <strong>80%</strong> <br /> zadowolonych klientów*
                            </Fragment>
                        }
                    />
                    <ContractorDescriptionPopup
                        css={offers}
                        text={
                            <Fragment>
                                <strong>70 000</strong> <br /> ofert <br /> nieruchomości
                            </Fragment>
                        }
                    />
                </div>

                <Text align="right" color={theme.colors.gray[600]} variant="info_txt_1">
                    *Badanie pracowni PBS
                </Text>
            </div>

            <RegisterCompanyButton />
        </section>
    );
};

const contractorDescription = css`
    ${p(5, 3)};
    max-width: 76.8rem;
    margin: 0 auto;
    ${flexAlignCenter};
    flex-direction: column;
`;

const content = css`
    ${pv(10)};
`;

const chartWrapper = (theme: Theme) => css`
    ${w100};
    ${p(2)};
    position: relative;

    @media (min-width: ${theme.breakpoints.sm}) {
        width: 44rem;
    }
`;

const chart = css`
    max-width: 100%;
    ${mb(2)};
`;

const clients = (theme: Theme) => css`
    left: 0;
    top: -20%;

    @media (min-width: ${theme.breakpoints.sm}) {
        left: 10rem;
        top: -10%;
    }
`;

const offers = (theme: Theme) => css`
    right: 0;
    bottom: 45%;

    @media (min-width: ${theme.breakpoints.sm}) {
        right: -1rem;
    }
`;
import React, {Fragment} from "react";
import {css, Theme, useTheme} from "@emotion/react";

import {flexAlignCenter, mb, p, pv, w100} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";

import {ContractorDescriptionPopup} from "./ContractorDescriptionPopup";
import {RegisterCompanyButton} from "./RegisterCompanyButton";

const chartImage = require("../images/chart.png");

export const ContractorDescription = () => {
    const theme = useTheme();

    return (
        <section css={contractorDescription}>
            <Text align="center" css={mb(3)} variant="headline_2">
                Ty projektujesz, my pomagamy Ci zyskać nowych klientów!
            </Text>
            <Text align="center">
                Zaufało nam ponad 1 000 renomowanych deweloperów, dzięki którym udostępniamy blisko 70 000 ofert. Satysfakcję naszych użytkowników podkreślają
                dane PBS. Ponad 80% z nich uznało, że Rynek Pierwotny jest dobrym miejscem na wyszukiwanie nowych ofert nieruchomości. Przekonaj się i Ty, załóż
                bezpłatny profil specjalisty i zyskaj nowych klientów.
            </Text>

            <div css={content}>
                <div css={chartWrapper}>
                    <img alt="chart" css={chart} src={chartImage} />

                    <ContractorDescriptionPopup
                        css={clients}
                        text={
                            <Fragment>
                                <strong>80%</strong> <br /> zadowolonych klientów*
                            </Fragment>
                        }
                    />
                    <ContractorDescriptionPopup
                        css={offers}
                        text={
                            <Fragment>
                                <strong>70 000</strong> <br /> ofert <br /> nieruchomości
                            </Fragment>
                        }
                    />
                </div>

                <Text align="right" color={theme.colors.gray[600]} variant="info_txt_1">
                    *Badanie pracowni PBS
                </Text>
            </div>

            <RegisterCompanyButton />
        </section>
    );
};

const contractorDescription = css`
    ${p(5, 3)};
    max-width: 76.8rem;
    margin: 0 auto;
    ${flexAlignCenter};
    flex-direction: column;
`;

const content = css`
    ${pv(10)};
`;

const chartWrapper = (theme: Theme) => css`
    ${w100};
    ${p(2)};
    position: relative;

    @media (min-width: ${theme.breakpoints.sm}) {
        width: 44rem;
    }
`;

const chart = css`
    max-width: 100%;
    ${mb(2)};
`;

const clients = (theme: Theme) => css`
    left: 0;
    top: -20%;

    @media (min-width: ${theme.breakpoints.sm}) {
        left: 10rem;
        top: -10%;
    }
`;

const offers = (theme: Theme) => css`
    right: 0;
    bottom: 45%;

    @media (min-width: ${theme.breakpoints.sm}) {
        right: -1rem;
    }
`;
